import { render, staticRenderFns } from "./List-Package-Size.vue?vue&type=template&id=0a4e90a4&scoped=true"
import script from "./List-Package-Size.vue?vue&type=script&lang=js"
export * from "./List-Package-Size.vue?vue&type=script&lang=js"
import style0 from "./List-Package-Size.vue?vue&type=style&index=0&id=0a4e90a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e90a4",
  null
  
)

export default component.exports